// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ActionButtons-module-wrapper-Pyf\\+3{display:flex;margin-bottom:32px;width:100%;gap:10px;flex-direction:column}@media(min-width: 960px){.ActionButtons-module-wrapper-Pyf\\+3{flex-direction:row;gap:20px}}.ActionButtons-module-button-fbf-S{max-height:40px;width:100%}@media(min-width: 960px){.ActionButtons-module-button-fbf-S{max-height:100%;width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "ActionButtons-module-wrapper-Pyf+3",
	"button": "ActionButtons-module-button-fbf-S"
};
export default ___CSS_LOADER_EXPORT___;
